module.exports = __webpack_public_path__ + "7f37054f24952f8a3317c0dbf56f4009.png";